import { defineRequest } from "../axios"
import type {
    AccountInfoResponse,
    AccountPermissionResponse,
    NotificationCounterResponse,
    NotificationSettings,
} from "./types"

// 取得用戶資訊
export const getAccountInfo = defineRequest<AccountInfoResponse>({
    url: "/accounts/current/",
    method: "get",
})

// 取得用戶權限
export const getAccountPermission = defineRequest<AccountPermissionResponse>({
    url: "/accounts/current/permissions/",
    method: "get",
})

// 取得用戶消息顯示設定
export const getAccountNotificationSettings = defineRequest<NotificationSettings>({
    url: "/accounts/current/notification-settings/",
    method: "get",
})

// 更新用戶消息顯示設定
export const updateAccountNotificationSettings = defineRequest<NotificationSettings, NotificationSettings>({
    url: "/accounts/current/notification-settings/",
    method: "put",
})

// 取得用戶通知計數
export const getAccountNotificationCounter = defineRequest<NotificationCounterResponse>({
    url: "/accounts/current/notification-counter/",
    method: "get",
})
